import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';


@Injectable({
    providedIn: 'root'
})
export class NativeBadgeCountService {
    constructor(private badge: Badge) {
        this.initialize().catch(err => {
            console.info('Badge plugin not available:', err);
        });
    }

    private async initialize() {
        const hasPermission = await this.badge.hasPermission();

        if (!hasPermission) {
            const granted = await this.badge.requestPermission();
            if (!granted) {
                console.warn('Badge permission was denied.');
            }
        }
    }

    async getBadgeCount(): Promise<number> {
        return await this.badge.get();
    }

    async increaseBadgeCount(count?: number): Promise<void> {
        if(!Capacitor.isNativePlatform()) return
        await this.badge.increase(count || 1).then(() => {
        }).catch(err => {
            console.error('Error increasing badge count:', err);
        });
    }

    async decreaseBadgeCount(count?: number): Promise<void> {
        await this.badge.decrease(count || 1);
    }

    async clearBadgeCount(): Promise<void> {
        await this.badge.clear();
    }
}
